import {LOGIN_TYPES} from "@const"
import {
    __DEV__,
    __TESTING__,
    __PROD__,
    frontend_local,
    frontend_dev,
    frontend_staging,
    frontend_prod
} from "./serverConfig"

export const msalConfig = {
    auth: {
        clientId: __PROD__ ? "bce1de47-5e5c-4ba3-84bb-76a018ddec69" : "6a44ed93-b8d1-4063-8efc-eea52c9b8407",
        authority: __PROD__ ? "https://login.microsoftonline.com/4da585ed-d638-4e1c-bf37-02b73167e1b4" :
            "https://login.microsoftonline.com/8ad52752-28db-43b8-a514-511b3e176967",
        redirectUri: __DEV__ ? frontend_local : __TESTING__ ? frontend_dev : __PROD__ ? frontend_prod : frontend_staging
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    // scopes: ["User.Read"]
    scopes: [
        __PROD__ ? "api://bce1de47-5e5c-4ba3-84bb-76a018ddec69/APIIT_student_managent_System" :
            "api://6a44ed93-b8d1-4063-8efc-eea52c9b8407/NewApiit.ExampleScope"
    ]
}

export const loginRequestStudent = {

    //using client id
    scopes: [
        __PROD__ ? "api://5dd905bd-c111-42fc-94fa-44bb3db3483f/apiit-prod-students" :
            "api://5dd905bd-c111-42fc-94fa-44bb3db3483f/apiit-prod-students"
    ]
}
export const msalConfigStudent = {

    auth: {

        clientId: __PROD__ ? "5dd905bd-c111-42fc-94fa-44bb3db3483f" : "5dd905bd-c111-42fc-94fa-44bb3db3483f",
        //using tenet id
        authority: __PROD__ ? "https://login.microsoftonline.com/86127bbe-1480-47ae-af35-1fcca1d323e4" :
            "https://login.microsoftonline.com/408465ef-ea4e-42ad-b377-511b3ee45465",
        redirectUri: __DEV__ ? frontend_local : __TESTING__ ? frontend_dev : __PROD__ ? frontend_prod : frontend_staging
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }

}


export const loginView = {
    type: LOGIN_TYPES.default,
    separateLogin: false
}

// temparaily tax set false .told by chamidi and sahan W
export const receiptTax = {
    taxAllow: false
}

export const batchPlan = {
    levelWiseOrientation: true
}

// don't change the order (if need have update util.js)
export const PAYMENT_INTERVALS = [
    {label: 'Monthly - 30 days ', value: '1-M-ANY'},
    {label: 'Annual - one time payment ', value: '12-M-ANY'},
    {label: '2 Semester - 3 months', value: '3-M-2'},
    {label: '2 Semester - 4 months', value: '4-M-2'},
    {label: '3 Semester - 3 months ', value: '3-M-3'},
    {label: `3 semesters - 4 months`, value: `4-M-3`},
    {label: '4 Semester - 4 months', value: '4-M-4'},
    {label: '5 Semester - 4 months', value: '4-M-5'},
    {label: '2 Semester - 6 months ', value: '6-M-2'}
    // {label: '1 Semester - 3 months', value: '3-M-1'},
    // {label: 'One time payment ', value: '1-M-1'}
]